(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('TransicaoSituacao', TransicaoSituacao);

    TransicaoSituacao.$inject = ['$resource'];

    function TransicaoSituacao($resource) {
        var resourceUrl = 'api/transicao-situacao/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'save': {method: 'POST'},
            'delete': {method: 'DELETE'},
            'permitidas': {
                method: 'GET',
                url: 'api/transicao-situacao/permitidas',
                isArray: true
            }
        });
    }
})();
